import React from 'react';
import { Body, CustomLink, Shape } from '@teko/ds-desktop';
import { IFormAdditonalButtons } from '../shared';

interface IAdditionalButtonsProps {
  additionalButtons: IFormAdditonalButtons[];
}

export const AdditionalButtons: React.FunctionComponent<
  IAdditionalButtonsProps
> = (props) => {
  const { additionalButtons } = props;
  return (
    <Shape>
      {additionalButtons.map(({ href, title, show, onClick }, index) => (
        <div key={index}>
          {show &&
            (href ? (
              <CustomLink href={href}>
                <Body color="link" level={1} margin={['s12', 's0']}>
                  {title}
                </Body>
              </CustomLink>
            ) : (
              <Body
                color="link"
                level={1}
                margin={['s12', 's0']}
                onClick={onClick}
                style={{ cursor: 'pointer' }}
              >
                {title}
              </Body>
            ))}
        </div>
      ))}
    </Shape>
  );
};
